import { render, staticRenderFns } from "./CardValidationDetail.vue?vue&type=template&id=246b550a&"
import script from "./CardValidationDetail.vue?vue&type=script&lang=js&"
export * from "./CardValidationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports